import { render, staticRenderFns } from "./InputTextAuth.vue?vue&type=template&id=270710f7&scoped=true&"
import script from "./InputTextAuth.vue?vue&type=script&lang=js&"
export * from "./InputTextAuth.vue?vue&type=script&lang=js&"
import style0 from "./InputTextAuth.vue?vue&type=style&index=0&id=270710f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270710f7",
  null
  
)

export default component.exports